import { Filter, FilterType, FilterKey } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '../..';
import { orderBy, uniqBy } from 'lodash';

const studentsEmptyTagId = 'None';

const parseTags = (tags: Array<{ label: string; value: string; type: string }>) => {
  const allTagOptions: { label: string; value: string }[] = [];

  tags.forEach((tag: { label: string; value: string; type: string }) => {
    const hasLabel = Boolean(tag?.label?.length);
    if (hasLabel) {
      allTagOptions.push({
        label: tag?.label,
        value: tag?.value,
      });
    }
  });

  const options = [
    ...allTagOptions,
    {
      label: 'None',
      value: studentsEmptyTagId,
    },
  ];

  return options;
};

const key = FilterKey.TAGS;
export const getTagsFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const tagsFilterOptions = filterOptions?.tags || [];

  // tags coming from the backend in some cases are with the same id/value but different type
  const tagsFilterOptionsUnique = uniqBy(tagsFilterOptions, 'value');

  const allTags = parseTags(tagsFilterOptionsUnique || []);

  const filters = activeFilters[key] ?? [];

  const options = allTags.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Tags',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
